export default {
	// Config
	apiKey: "AIzaSyCRQaIPMGc0zuHQMvJ9n5_7ia-pglEnAtY",
  authDomain: "mazaya-mytrace.firebaseapp.com",
  projectId: "mazaya-mytrace",
  storageBucket: "mazaya-mytrace.firebasestorage.app",
  messagingSenderId: "522096398492",
  appId: "1:522096398492:web:17de9670fa572df1c91d59"
};
